// generated by genversion
export var version = '3.8.7';